var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"24","height":"24"}},[_c('path',{attrs:{"d":"M13 6l-.001 5H18v2h-5.001L13 18h-2l-.001-5H6v-2h4.999L11 6h2z","fill":"currentColor","fill-rule":"evenodd"}})])}
var staticRenderFns = []

export { render, staticRenderFns }